import React, { useRef, useState } from 'react';
import { useSnapshot } from 'valtio';
import { useNavigate } from 'react-router-dom';
import { state } from '../../store/global';
import api from '../../lib/api';

import LoginRightWrapper from '../../components/common/LoginRightWrapper';
import LoginLeftSide from '../../components/common/LoginLeftSide';
import LoginFooter from '../../components/common/LoginFooter';
import SuccessMessage from '../../components/common/SuccessMessage';

export default function ForgotPasswordSuccess() {
  const snap = useSnapshot(state);
  const navigate = useNavigate();

  const onGoToPage = (path) => {
    navigate(path);
  };

  return (
    <div className="flex min-h-screen">
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        {/* Modal content with exact size */}
        <div className="relative z-10 bg-white rounded-2xl shadow-xl w-[1044px] h-[700px] overflow-hidden">
          <div className="flex flex-col md:flex-row w-full h-full">
            {/* Left Side - Image */}
            <LoginLeftSide />

            {/* Right Side - Form */}
            <div className="w-full h-full flex flex-col justify-between md:w-1/2 p-10 bg-[#F9F9F9]">
              <LoginRightWrapper
                onGoToPage={(path) => onGoToPage(path)}
                backPath="/forgotPassword/reset"
              />

              <div>
                <div className="pl-0 pr-0 md:pl-14 md:pr-14">
                  <SuccessMessage
                    title="Contraseña actualizada"
                    description={[
                      'Tu contraseña ha sido actualizada con éxito.',
                    ]}
                    buttonText="Volver al inicio"
                    onClick={() => navigate('/login')}
                  />
                  <div className="h-10 bg-[#F9F9F9]" />
                </div>
              </div>

              {/* Login footer */}
              <LoginFooter onClick={() => navigate('/contact')} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
